import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const targetSectorDefinition: ResourceDefinition = {
  title: 'Target Sectors',
  nameSingular: 'Target Sector',
  namePlural: 'Target Sectors',
  className: 'TargetSector',
  mainIdentifier: 'name',
  slug: 'taxonomies/target-sectors',
  path: 'target-sectors',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (targetSector) => ({
        type: ActionType.Link,
        link: {
          path: `${targetSectorDefinition.path}/${targetSector.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (targetSector) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: targetSector,
          definition: targetSectorDefinition
        }
      })
    }
  ]
}
